import React from "react";
import ProjectOverviewChart from "./ProjectOverviewChart";

const ProjectOverviewTab = ({ height, dashboardChart, viewType = "water" }) => {
  return (
    <div className="card overflow-hidden">
      <ProjectOverviewChart
        height={height}
        dashboardChart={dashboardChart}
        viewType={viewType}
      />
    </div>
  );
};

export default ProjectOverviewTab;
